"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapIsVerified = void 0;
const mapIsVerified = (checkTrustedVerificationStatusResponse) => checkTrustedVerificationStatusResponse.message.toLowerCase() === 'success';
exports.mapIsVerified = mapIsVerified;
//# sourceMappingURL=mapper.js.map